module.exports = __webpack_public_path__ + "static/media/assessment-end-screen-footer.5e3a11f1.png";